import { ResponseExport, ResponseGraphics, ResponseTable } from '../models/common-payments';
import { ExportDataParams, ExportPdf, GetQuickTransfer } from '../models/quick-transfer';
import { client } from '../utils/api';
import { exportParamsConstructor, tableParamsConstructor } from '../utils/common';

const getGraphicsData = async (merchantCode: string) => {
	try {
		const params = { merchant_code: merchantCode };
		const { data } = await client.get<ResponseGraphics>('/v1/qt/graphics', { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getAllPayments = async ({ ...rest }: GetQuickTransfer) => {
	try {
		const params = tableParamsConstructor(rest);
		const { data } = await client.get<ResponseTable>('/v1/qt/table', { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getExportData = async ({ ...rest }: ExportDataParams) => {
	try {
		const params = exportParamsConstructor(rest);
		const { data } = await client.get<ResponseExport>('/v1/qt/export', { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getExportPdf = async ({ ...rest }: ExportPdf) => {	
	try {
		const params = exportParamsConstructor(rest);

		const { data } = await client.get<ResponseExport>('/v1/common/create-voucher', { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const QuickTransferServices = {
	getGraphicsData,
	getAllPayments,
	getExportData,
	getExportPdf,
};
